import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
const locales = [{
  id: 'fr',
  label: 'FR',
  name: 'Français'
}, {
  id: 'en',
  label: 'EN',
  name: 'English'
}] as const;

/** Bascule FR / EN de l'en-tête : traduit tout le contenu affiché. */
export function LanguageToggle() {
  const {
    locale,
    setLocale
  } = useLanguage();
  return <div data-no-translate role="group" aria-label="Langue du site / Site language" className="flex shrink-0 items-center rounded-full border border-slate-200 p-0.5" data-id="element-1824" data-mp="2t8jparmdrrgz">
      {locales.map(option => {
      const active = locale === option.id;
      return <button key={option.id} type="button" lang={option.id} aria-pressed={active} onClick={() => setLocale(option.id)} title={option.name} className={`rounded-full px-2.5 py-1.5 text-xs font-bold transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue ${active ? 'bg-ville-navy text-white' : 'text-ville-deep hover:bg-ville-mist'}`} data-id="element-1825" data-mp="2f9aanwdtp5f4">
            {option.label}
          </button>;
    })}
    </div>;
}